/**
 * Created by lakshan on 6/6/17.
 */
(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name messageAdmin.service:MessageAdminService
   *
   * @description
   *
   */
  angular.module('messageAdmin').service('MessageAdminService', MessageAdminService);

  function MessageAdminService(MessageAdminFactory, RemoteService, CommonMasterData, MessageAdminAdaptorFactory) {

    var self = this;

    function EditMessageCrewDTO(){
      this.crewProfileId = null;
      this.displayName = null;
      this.selected = false;
    }

    // store retrieved data
    var model = {
      formattedMessageList : [],
      messageAdminSearchRequest : MessageAdminFactory
        .getMessageAdminSearchRequest(),
      deleteMessageRequest : MessageAdminFactory
        .getMessageDeleteRequest(),
        allCrewList : null,
      newEditMessage : MessageAdminFactory.getNewEditMessage(),
      saveMessageRequest : MessageAdminFactory.getMessageAdminSaveRequest()
    };

    self.setMessageAdminSearchRequest = function(searchCrieteria) {
      model.messageAdminSearchRequest = MessageAdminFactory
        .getFormattedMessageAdminSearchRequest(searchCrieteria);
    }

    self.searchMessages = function(successFn, errorFn) {
      RemoteService.searchMessages(model.messageAdminSearchRequest).then(
        function(response) {
          if (response.success && !!response.msgList) {
            successFn(response.msgList);
          }
        }, function(error) {
          errorFn(error.msg[0]);
        });
    };

    self.getNewEditMessage = function(){
    	model.newEditMessage = MessageAdminFactory.getNewEditMessage();
    	model.newEditMessage.msgPriority = 3;//default value
    	getMessagePriorityObject(model.newEditMessage);
    	return model.newEditMessage;
    }

    self.getMessageEdit = function(message){
      var editMessage = MessageAdminFactory.getFormattedEditMessage(message);
      if(!!editMessage.crewProfileIds){
    	  editMessage.assignedCrew = setAssignCrewList(editMessage.crewProfileIds);
      }
      //getMessagePriorityObject(editMessage);
      getMessageCategoryObject(editMessage);
      return editMessage;
    };

    function setAssignCrewList(crewProfileIds){
    	var assignCrewList = [];
    	for(var i = 0 ; i < crewProfileIds.length ; i++ ){
    		var crew = _.find(model.allCrewList, {
    			crewProfileId : crewProfileIds[i]
    	        });
    		if(!!crew){
    			assignCrewList.push(crew);
    		}
    	}
    	return assignCrewList;
    }

    self.getNotSelectedCrewList = function(crewlist, message){
    	var notSelectedCrewList = [];
    	if(!!message && !!message.msgUserProfileIds){
    		for(var i = 0; i < crewlist.length ; i++){
    			if(message.msgUserProfileIds.indexOf(crewlist[i].crewProfileId) === -1){
    				notSelectedCrewList.push(crewlist[i]);
    			}
    		}
    		return notSelectedCrewList;
    	}
    	return crewlist;
    }

    // get message priority object for edit panel combo box
    function getMessagePriorityObject(editMessage) {
      CommonMasterData.getMessagePrioritiesList(function(messagePriorities) {
        editMessage.msgPriority = _.find(messagePriorities, {
          value : Number(editMessage.msgPriority)
        });
      }, function() {
        console.log('Message Priorities list retrieval error');
      });
    };

    // get message priority object for grid panel
    self.getMessagePriorityObjectForGrid = function(editMessage) {
      var priority = "";
      CommonMasterData.getMessagePrioritiesList(function(messagePriorities) {
        priority = _.find(messagePriorities, {
          value : Number(editMessage.msgPriority)
        });
      }, function() {
        console.log('Message Priorities list retrieval error');
      });
      return priority;
    };

    // get message category object for edit panel combo box
    function getMessageCategoryObject(editMessage) {
      CommonMasterData.getMessageCategoryList(function(messageCategories) {
        editMessage.categoryCode = _.find(messageCategories, {
          messageCategoryCode : editMessage.categoryCode
        });
        if(editMessage.categoryCode == null){
        	editMessage.categoryCode = { messageCategoryCode : null};
        }
      }, function() {
        console.log('Message Category list retrieval error');
      });
    };

    // delete
    self.deleteMessage = function(selectedMessage,
                                            successFn, errorFn) {
      model.deleteMessageRequest = MessageAdminFactory
        .getFormattedMessageDeleteRequest(selectedMessage);
      RemoteService.deleteMessage(
        model.deleteMessageRequest).then(
        function(response) {
          successFn(response);
        }, function(error) {
          errorFn(error);
        });
    };

    self.saveMessage = function(formFiles, selectedMessage,
            successFn, errorFn){
    	model.saveMessageRequest = MessageAdminFactory
        .getMessageAdminFormattedSaveRequest(selectedMessage);
      var formData = formFiles;
      var adaptedFormData = MessageAdminAdaptorFactory.adaptFormSubmit(formData, model.saveMessageRequest);
      RemoteService.submitAsFormRequest('messageManageUpload', adaptedFormData, successFn, errorFn);
    };

    self.adaptCrewList = function (crewList) {
      var newCrewList = [];
      if (!!crewList && crewList.length > 0) {
        for (var i = 0; i < crewList.length; i++) {
          var newCrew = new EditMessageCrewDTO();
          newCrew.crewProfileId = crewList[i].crewProfileId;
          newCrew.displayName = crewList[i].firstName + ' ' + crewList[i].lastName;
          newCrewList.push(newCrew);
        }
      }
      return newCrewList;
    };

    self.getFormattedMessageList = function(messages , categoryList){
    	model.formattedMessageList = MessageAdminFactory.getFormattedMessageList(messages , categoryList);
    	return model.formattedMessageList;
    }

    self.getsettedAllCrewList = function(){
    	return model.allCrewList;
    };

    self.getAllCrewList = function(successFn, errorFn) {
        if(model.allCrewList == null){
        	RemoteService.getAllCrewDisplayNameList().then(
        	          function(response) {
        	            if (response.success && !!response.crewDetail) {
        	            	model.allCrewList = response.crewDetail;
        	              successFn(MessageAdminFactory.setSelectedFlag(response.crewDetail));
        	            }
        	          }, function(error) {
        	            errorFn(error.msg[0]);
        	          });
        }else{
        	return model.allCrewList;
        }
      };
  }
})();
